export function getCurrentDateString() {
  const now = new Date();
  const year = now.getFullYear();
  const month = (now.getMonth() + 1).toString().padStart(2, "0");
  const day = now.getDate().toString().padStart(2, "0");
  return `${year}${month}${day}`;
}

export function formatDisplayDate(date = new Date()) {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, "0");
  const day = date.getDate().toString().padStart(2, "0");
  return `${month}-${day}-${year}`;
}

export function getPreviousDateString(daysAgo) {
  const currentDate = getCurrentDateString();
  const baseDate = new Date(
    Number(currentDate.slice(0, 4)),
    Number(currentDate.slice(4, 6)) - 1,
    Number(currentDate.slice(6, 8))
  );
  const previousDate = new Date(baseDate);
  previousDate.setDate(baseDate.getDate() - daysAgo);

  const year = previousDate.getFullYear().toString();
  const month = (previousDate.getMonth() + 1).toString().padStart(2, "0");
  const day = previousDate.getDate().toString().padStart(2, "0");

  return `${year}${month}${day}`;
}
